import { render } from "./PageWholesaleRate.vue?vue&type=template&id=42a4bd6d"
import script from "./PageWholesaleRate.vue?vue&type=script&lang=js"
export * from "./PageWholesaleRate.vue?vue&type=script&lang=js"

import exportComponent from "/home/glassplant/agi.co.jp/roots-prod/vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__